export const isEmpty = (value: object) =>
  Object.values(value).every((x) => x === null || x === "");
export const isJsonString = (str: string) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

